export default __webpack_public_path__ + "assets/icons/home_chaxun.72265927.svg";